import React, { useState } from 'react'
import Logo from '../Components/Images/reccur logo.svg'
import { MdMenu } from 'react-icons/md'
import { RiArrowRightSLine } from 'react-icons/ri'
import Footer from '../Components/Footer'
import HomeNavBar from '../Components/HomeNavBar'
import bg from '../Components/Images/bg2.png'
import { useLocation } from 'react-router-dom';
import newLogo from '../Components/Images/newLogo.png'
import countries from '../Components/Images/countries2.png'
import FAQ2 from '../Components/FAQ2'

const HowItWorks = () => {

    const [openMenu, setOpenMenu] = useState(false)
    const location = useLocation()

    return (
        <div className='3xl:text-2xl mk:text-lg sd:text-[17px] text-[14px]'>
            <div>
                <div className='sd:m-10'>
                    <div
                        className="relative w-full rounded-[20px] bg-[#E8E1F5]"
                        style={{
                            backgroundImage: `url(${bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: '#E8E1F5'
                        }}
                    >
                        <div className='relative w-full top-0 rounded-[20px] z-50 text-black sd:px-12 px-2 sd:py-12 py-4 pb-16'>
                            <div className='relative'>
                                <div className='flex justify-between items-center px-2'>
                                    <a href="/">
                                        <div className='flex gap-2 items-center'>
                                            <img src={Logo} className='mk:w-auto w-5' alt="" />
                                            <p className='font-medium'>reccur</p>
                                        </div>
                                    </a>
                                    <div className='lg:flex hidden gap-8 ml-24'>
                                        <a href="/use_cases">
                                            <p className={`${location.pathname === '/use_cases' && 'font-bold'}`}>Use cases</p>
                                        </a>
                                        <a href="/how_it_works">
                                            <p className={`${location.pathname === '/how_it_works' && 'font-bold'}`}>How it Works</p>
                                        </a>
                                        <a href="/about">
                                            <p className={`${location.pathname === '/about' && 'font-bold'}`}>About</p>
                                        </a>
                                    </div>
                                    <div className='lg:flex hidden'>
                                        <a href="/login">
                                            <button className='py-2 px-[14px]'>Log in</button>
                                        </a>
                                        <a href="/signup">
                                            <button className='bg-[#531CB3] font-light text-white py-2 px-[14px] rounded-[10px]'>
                                                Get started
                                            </button>
                                        </a>
                                    </div>
                                    <MdMenu onClick={() => setOpenMenu(!openMenu)} className='lg:hidden cursor-pointer sh:text-[30px] text-xl' />
                                </div>

                                <div className='flex lg:flex-row flex-col justify-between gap-6 w-full sd:mt-20 mt-5 lg:items-start items-center'>
                                    <div className='w-full flex flex-col items-center gap-6'>
                                        <img className='sd:size-32 size-24' src={newLogo} alt="" />
                                        <p className='font-semibold 3xl:text-5xl text-center text-4xl'>Your guide to getting  <br className='sk:block hidden' /> paid globally</p>
                                        <div className='flex mh:flex-row flex-col text-center items-center mh:gap-9 gap-5 mt-5 text-[#302F33]'>
                                            <p className='flex gap-3 items-center'>
                                                <span className='text-white rounded-full px-[8px] bg-[#271D2E]'>1</span>
                                                Sign up (5 mins)
                                            </p>
                                            <p className='flex gap-3 items-center'>
                                                <span className='text-white rounded-full px-[8px] bg-[#271D2E]'>2</span>
                                                Share Your New Banking Details
                                            </p>
                                            <p className='flex gap-3 items-center'>
                                                <span className='text-white rounded-full px-[8px] bg-[#271D2E]'>3</span>
                                                Funds Land as USDC
                                            </p>
                                        </div>
                                        <div className='flex mh:flex-row flex-col text-center items-center mh:gap-9 gap-5 mt-1 text-[#302F33]'>
                                            <p className='flex gap-3 items-center'>
                                                <span className='text-white rounded-full px-[8px] bg-[#271D2E]'>4</span>
                                                Do More Than Just “Withdraw”
                                            </p>
                                            <p className='flex gap-3 items-center'>
                                                <span className='text-white rounded-full px-[8px] bg-[#271D2E]'>5</span>
                                                Security & Compliance Built‑In
                                            </p>
                                        </div>
                                        <a href="/signup">
                                            <button className='bg-[#531CB3] text-white flex gap-2 items-center justify-center sh:py-[14px] py-[9px] px-[24px] shadow-md shadow-[#531CB3] rounded-lg'>
                                                Get started
                                                <RiArrowRightSLine className='size-7' />
                                            </button>
                                        </a>
                                        <div className='flex items-center gap-0'>
                                            <img className='3xl:w-36 sd:w-28 w-[70px]' src={countries} alt="" />
                                            <p className='text-[#525154] font-normal'>Open a bank account in 30+ countries.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <HomeNavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
                        </div>
                    </div>
                </div>
                <div className="">
                    {/* STEP 1 */}
                    <div className="px-5 sm:px-8 lg:px-20 2xl:px-32 py-16 sm:py-24 lg:py-40">
                        <p className="text-sm sm:text-base">STEP 1</p>
                        <p className="text-2xl sm:text-4xl lg:text-[41px] font-semibold mt-3 sm:mt-5">
                            Sign up
                        </p>
                        <p className="text-[#525154] mt-4 sm:mt-5 text-sm sm:text-base">
                            Sign up in just a few minutes and complete a quick identity verification
                            to start <br className="hidden sm:block" /> your journey with Reccur.
                        </p>

                        <div className="border border-[#0000003D] mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                            {[
                                {
                                    num: 1,
                                    title: "Kick things off",
                                    text: "Hit “Sign Up” to start your journey—takes less than a minute.",
                                },
                                {
                                    num: 2,
                                    title: "Quick identity check",
                                    text: "Snap a clear photo of your ID and proof of address—no endless forms.",
                                },
                                {
                                    num: 3,
                                    title: "Share the basics",
                                    text: "Just your name and email, nothing complicated.",
                                },
                                {
                                    num: 4,
                                    title: "You’re All Set",
                                    text: "Your personal USD ACH account and EUR IBAN are instantly issued.",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${idx < 3 ? "sm:border-r" : ""} ${idx < 2 ? "sm:border-b-0" : ""
                                        } border-b sm:border-b bg-[#FAF9FD] border-[#0000003D] w-full`}
                                >
                                    <div className="flex bg-white items-center px-4 sm:px-6 lg:px-4 2xl:px-8 text-[#302F33]">
                                        <p className="pr-4 sm:pr-6 lg:pr-4 2xl:pr-8 py-4 lg:py-7 border-r border-[#0000003D] text-sm sm:text-base">
                                            {item.num}
                                        </p>
                                        <p className="pl-3 sm:pl-4 lg:pl-2 2xl:pl-6 lg:py-7 text-sm sm:text-[15px] 2xl:text-lg 3xl:text-2xl">
                                            {item.title}
                                        </p>
                                    </div>
                                    <div className="bg-[#FAF9FD] border-t border-[#0000003D] text-[#525154] py-4 lg:py-7 px-4">
                                        <p className="text-sm sm:text-base">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* STEP 2 */}
                    <div className="px-5 sm:px-8 lg:px-20 2xl:px-32 bg-[#FEEDED] py-16 sm:py-24 lg:py-40">
                        <p className="text-sm sm:text-base text-[#DC2626]">STEP 2</p>
                        <p className="text-2xl sm:text-4xl lg:text-[41px] font-semibold mt-3 sm:mt-5 leading-tight text-[#DC2626]">
                            Share your new <br className="hidden sm:block" /> banking details
                        </p>
                        <p className="text-[#525154] mt-4 sm:mt-5 text-sm sm:text-base">
                            Send your account details in seconds—perfect for invoices, clients, <br className="hidden sm:block" /> and quick payments.
                        </p>

                        <div className="border border-[#DC26263D] mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2">
                            {[
                                {
                                    num: 1,
                                    title: "Add your banking info",
                                    text: "Copy and paste your new account details into an invoice or send them directly to your client—it’s that simple.",
                                },
                                {
                                    num: 2,
                                    title: "Receive your payment",
                                    text: "Clients can send USD via ACH or EUR via SEPA straight into your account. You can also pull funds from PayPal or a traditional bank.",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${idx === 0 ? "sm:border-r" : ""} border-b sm:border-b bg-[#FAF9FD] border-[#DC26263D]`}
                                >
                                    <div className="flex items-center px-4 bg-[#FEEDED] sm:px-6 lg:px-8 text-[#302F33]">
                                        <p className="pr-4 sm:pr-6 lg:pr-8 py-4 lg:py-7 border-r border-[#DC26263D] text-sm sm:text-base">
                                            {item.num}
                                        </p>
                                        <p className="pl-4 lg:pl-8 lg:py-7 text-sm sm:text-lg 3xl:text-2xl">{item.title}</p>
                                    </div>
                                    <div className="bg-[#FAF9FD] border-t border-[#DC26263D] text-[#525154] py-4 lg:py-7 px-4 lg:px-8">
                                        <p className="text-sm sm:text-base">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* STEP 3 */}
                    <div className="px-5 sm:px-8 lg:px-20 2xl:px-32 bg-[#E8E1F5] py-16 sm:py-24 lg:py-40">
                        <p className="text-sm sm:text-base text-[#431594]">STEP 3</p>
                        <p className="text-2xl sm:text-4xl lg:text-[41px] font-semibold mt-3 sm:mt-5 leading-tight text-[#431594]">
                            Funds land as USDC <br className="hidden sm:block" /> (dollar-stable)
                        </p>
                        <p className="text-[#525154] mt-4 sm:mt-5 text-sm sm:text-base">
                            Your money stays steady—no currency swings, no surprises.
                        </p>

                        <div className="border border-[#4315943D] mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                            {[
                                {
                                    num: 1,
                                    title: "Transfer clears",
                                    text: "ACH lands T+1 and SEPA Instants land same day. The bank credit hits our partner and we’re good to go.",
                                },
                                {
                                    num: 2,
                                    title: "Funds settle 1:1",
                                    text: "We credit the money exactly as sent (USD/EUR, etc.) to your Reccur balance—no forced conversion.",
                                },
                                {
                                    num: 3,
                                    title: "No FX, no waiting",
                                    text: "No hidden FX spread and no multi-day holds. Your funds are ready to use right away.",
                                },
                                {
                                    num: 4,
                                    title: "Keep it stable",
                                    text: "Hold your balance in its original currency to avoid local volatility. Convert only when you choose.",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${idx < 3 ? "sm:border-r" : ""} border-b bg-[#F0ECF9] sm:border-b border-[#4315943D]`}
                                >
                                    <div className="flex items-center px-4 bg-[#E8E1F5] sm:px-6 3xl:px-8 text-[#302F33]">
                                        <p className="pr-4 sm:pr-6 lg:pr-8 py-4 lg:py-7 border-r border-[#4315943D] text-sm sm:text-base">
                                            {item.num}
                                        </p>
                                        <p className="pl-4 lg:pl-8 lg:py-7 text-sm sm:text-lg 3xl:text-2xl">{item.title}</p>
                                    </div>
                                    <div className="bg-[#F0ECF9] border-t border-[#4315943D] text-[#525154] py-4 lg:py-7 px-4 3xl:px-8">
                                        <p className="text-sm sm:text-base">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* STEP 4 */}
                    <div className="bg-[#271D2E] text-white px-5 sm:px-8 lg:px-20 2xl:px-32 py-16 sm:py-24 lg:py-40">
                        <p className="text-sm sm:text-base">STEP 4</p>
                        <p className="text-2xl sm:text-4xl lg:text-[41px] font-semibold mt-3 sm:mt-5">
                            Do more than just withdraw
                        </p>
                        <p className="text-[#E8E1F5] mt-4 sm:mt-5 text-sm sm:text-base">
                            Beyond cash out, unlock more ways to use your balance.
                        </p>

                        <div className="border border-[#FFFFFF3D] mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                            {[
                                {
                                    num: 1,
                                    title: "Cash out to NGN",
                                    text: "Select your NGN bank and enter the amount. Payouts land in minutes, 24/7.",
                                },
                                {
                                    num: 2,
                                    title: "Pay a teammate",
                                    text: "Pick the country and add their bank or M-Pesa details. Delivered same-day.",
                                },
                                {
                                    num: 3,
                                    title: "Send crypto",
                                    text: "Paste any self-custody wallet (e.g., Polygon / Base). Transfers go through in under ~60 seconds.",
                                },
                                {
                                    num: 4,
                                    title: "Hold & earn",
                                    title2: "Coming soon",
                                    text: "Keep funds in their original currency for stability; turn on yield when available.",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${idx < 3 ? "sm:border-r" : ""} border-b bg-[#35273F] sm:border-b border-[#FFFFFF3D]`}
                                >
                                    <div className="flex items-center bg-[#271D2E] px-4 sm:px-6 lg:px-8">
                                        <p className="pr-4 sm:pr-6 lg:pr-8 py-4 lg:py-7 border-r border-[#FFFFFF3D] text-sm sm:text-base">
                                            {item.num}
                                        </p>
                                        <div className="flex items-center justify-between w-full">
                                            <p className="pl-4 lg:pl-3 lg:py-7 text-sm sm:text-[17px] 3xl:text-2xl">{item.title}</p>
                                            {item.title2 && (
                                                <p className="py-1 px-[6px] text-[#D97706] bg-[#FEEDB8] ml-6 rounded text-[12px] 3xl:text-sm">{item.title2}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="bg-[#35273F] border-t border-[#FFFFFF3D] text-[#E8E1F5] py-4 lg:py-7 px-4 lg:px-8">
                                        <p className="text-sm sm:text-base">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* STEP 5 */}
                    <div className="px-5 sm:px-8 lg:px-20 2xl:px-32 py-16 sm:py-24 lg:py-40 bg-[#E8E1F5]">
                        <p className="text-sm sm:text-base text-[#431594]">STEP 5</p>
                        <p className="text-2xl sm:text-4xl lg:text-[41px] text-[#431594] font-semibold mt-3 sm:mt-5">
                            Security & Compliance Built-In
                        </p>
                        <p className="text-[#525154] mt-4 sm:mt-5 text-sm sm:text-base">
                            Protecting your funds with world-class safeguards.
                        </p>

                        <div className="border border-[#4315943D] mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                            {[
                                {
                                    num: 1,
                                    title: "Secure by Design",
                                    text: "MPC custody and multi-sig approvals protect crypto flows; sensitive actions require verified sign-off.",
                                },
                                {
                                    num: 2,
                                    title: "Verified balances",
                                    text: "Fiat funds are held with licensed banking partners and reconciled daily—statements and records are always available.",
                                },
                                {
                                    num: 3,
                                    title: "Compliance First",
                                    text: "Tier-1 KYC/AML with liveness checks, sanctions/PEP screening, and ongoing fraud monitoring keep bad actors out.",
                                },
                                {
                                    num: 4,
                                    title: "Fortified Systems",
                                    text: "ISO-27001–aligned controls, encryption in transit and at rest, regular pen-tests, and 24/7 monitoring.",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${idx < 3 ? "sm:border-r" : ""} border-b bg-[#F0ECF9] sm:border-b border-[#4315943D]`}
                                >
                                    <div className="flex items-center px-2 bg-[#E8E1F5] sm:px-6 3xl:px-8 text-[#302F33]">
                                        <p className="pr-4 sm:pr-6 lg:pr-8 py-4 lg:py-7 border-r border-[#4315943D] text-sm sm:text-base">
                                            {item.num}
                                        </p>
                                        <p className="pl-4 lg:pl-8 lg:py-7 text-sm sm:text-lg 3xl:text-2xl">{item.title}</p>
                                    </div>
                                    <div className="bg-[#F0ECF9] border-t border-[#4315943D] text-[#525154] py-4 lg:py-7 px-2 3xl:px-8">
                                        <p className="text-[13px] sm:text-[15px]">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <FAQ2 />
                <Footer />
            </div>
        </div >
    )
}

export default HowItWorks